



























































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import Edit from "@/components/Projects/Edit.vue";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { axios } from "@/plugins";

const TableHeaders: Header[] = [
  { title: "名称", key: "" },
  { title: "项目管理员", key: "createBy" },
  { title: "最大CPU", key: "", minWidth: 150 },
  { title: "最大内存", key: "", minWidth: 150 },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];

export default Vue.extend({
  name: "Projects",
  components: { TableLayout, Edit },
  props: { tenantId: { type: String } },
  data() {
    return {
      TableHeaders
    };
  },
  computed: {
    ...mapState("Projects", [
      "pages",
      "pageNum",
      "total",
      "filterValue",
      "loading",
      "hasNext"
    ]),
    ...mapGetters("Projects", ["tableData"])
  },
  mounted() {
    this.getData(`&tenantId=${this.tenantId}`);
  },
  beforeDestroy() {
    this.ClearStateMutation();
  },
  methods: {
    ...mapMutations("LoginInfo", { setProject: "SET_PROJECT" }),
    ...mapActions("Projects", ["getData", "delete", "search", "turnPage"]),
    ...mapMutations("Projects", ["ClearStateMutation"]),
    create(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(id: string, name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({ id, append: `&tenantId=${this.tenantId}` }).then(() => {
          this.$message.success("删除成功");
        });
      });
    },
    projectSearch(value: string) {
      this.search({ value, append: `&tenantId=${this.tenantId}` });
    },
    getPermission(projectId: any) {
      return axios.get(`/project/${projectId}/permission`);
    },
    setRouter(data: any) {
      this.getPermission(data.id).then((res: any) => {
        // 拥有该项目权限
        if (res.data.data) {
          // 使用 sessionStorage 会导致复制链接无法获取 MyProject
          // 将项目存入 sessionStorage
          // sessionStorage.setItem("MyProject", JSON.stringify(data));
          this.$router.push({
            name: "PrjOverview",
            params: { projectId: data.id }
          });
          this.setProject(data);
        }
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;
        case "delete":
          this.del(data.id, data.projectName);
          break;
        case "quota":
          (this.$refs.quota as any)?.show(data.id);
          break;
      }
    }
  }
});
